import React from "react";
import { Doughnut } from "react-chartjs-2";


const ChatDonut = ({ jobRunning, jobWaiting, UnusedNodes, UnusedCore, UnusedGpus }) => {
  const data = {
    labels: ["Job Running", "Job Waiting", "Unused Nodes", "Unused Cores", "Unused GPUs"],
    datasets: [
      {
        data: [jobRunning, jobWaiting, UnusedNodes, UnusedCore, UnusedGpus],
        backgroundColor: ["#66BB6A", "#FFCA28", "#42A5F5", "#FF7043", "#D4E157"],
        hoverBackgroundColor: ["#4CAF50", "#FFB300", "#2979FF", "#F4511E", "#CDDC39"]
      }
    ]
  };

  return <Doughnut  data={data} />;
};

export default ChatDonut;